module.exports = __webpack_public_path__ + "img/real-area-nothing.dbc2a97b.png";